function replaceCharacters(inputString) {
  const regexT = new RegExp("\t", "g");
  const regexR = new RegExp("\r", "g");
  const regexN = new RegExp("\n", "g");
  return inputString
    .replace(regexT, "&bsol;t")
    .replace(regexR, "&bsol;r")
    .replace(regexN, "&bsol;n");
}

export function textFormatter(text) {
  if (!text) {
    return text;
  }
  return replaceCharacters(text);
}
